import { type ReactNode, useEffect } from 'react'

import cn from 'classnames'

import { useModal } from 'mmfintech-commons'
import { useLocation } from 'react-router-dom'

import { ModalCloseIcon } from '@icons'

import './modalDialog.scss'

type ModalDialogOptions = {
  closeOnClickOutside?: boolean
  closeOnEscape?: boolean
  hideCloseIcon?: boolean
  scrollable?: boolean
  maxWidth?: number
}

type ModalDialogProps = {
  content: ReactNode
  options?: ModalDialogOptions
  visible?: boolean
  onClose?: () => void
}

const ModalDialog = ({ content, options, visible, onClose }: ModalDialogProps) => {
  const { ref, width, checkWidth, handleClose, overflowing, modalOptions, handleMouseDown } = useModal({
    options,
    visible,
    onClose
  })

  const location = useLocation()

  // biome-ignore lint/correctness/useExhaustiveDependencies: close modal when location change and is visible
  useEffect(() => {
    if (visible) {
      onClose?.()
    }
  }, [location.pathname])

  return visible ? (
    <div
      onMouseDown={handleMouseDown}
      className={cn('modal-dialog-wrapper', { overflowing: overflowing || width < checkWidth })}
      ref={ref}
    >
      <div
        className={cn('modal-container', `icon-${modalOptions.closeIconPosition}`, {
          scrollable: modalOptions.scrollable
        })}
      >
        <div className='popup-main-content' onMouseDown={e => e.stopPropagation()}>
          {content}
          {!modalOptions.hideCloseIcon && (
            <div className='popup-close-button-inline' onClick={handleClose}>
              <ModalCloseIcon />
            </div>
          )}
        </div>
        {!modalOptions.hideCloseIcon && (
          <div className='popup-close-button' data-test='popup-close-button' onClick={handleClose}>
            <ModalCloseIcon />
          </div>
        )}
      </div>
    </div>
  ) : null
}

export default ModalDialog
